import { UpdateUser } from '../../domain/usecases/update-user';

import { BaseHttpService } from 'main/factories/http';

export class RemoteUpdateUser extends BaseHttpService<UpdateUser.Model> implements UpdateUser {
  async update(body: UpdateUser.Params): Promise<UpdateUser.Model> {
    return await this.request('post', body);
  }
}
